module.exports = __webpack_public_path__ + "img/tuboDreno1.1d5f7c9b.jpg";